import ManualPages from "./ManualPages";
export default ManualPages;